import { render, staticRenderFns } from "./form4.vue?vue&type=template&id=0ad81ec6&scoped=true&"
import script from "./form4.vue?vue&type=script&lang=js&"
export * from "./form4.vue?vue&type=script&lang=js&"
import style0 from "./form4.vue?vue&type=style&index=0&id=0ad81ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad81ec6",
  null
  
)

export default component.exports